import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { GetCulture, saveCulture } from './index';

// Api's
import { cultureApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getCultureSaga(action: GetCulture) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      cultureApi.getDomain,
      action.payload.request
    );
    if (response.data.result) {
      yield put(saveCulture(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveCulture(null, true, resultError.messagesDataError));
    }
  }
}
